import React from 'react';
import { Link } from 'react-router-dom';
import './ReportsHero.css';

// You can reuse the graphic from the StatsHero component
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const ReportsHero = () => {
  return (
    <section className="reports-hero-section">
      <div className="reports-hero-content">
        <h1>CRISHI reports - the commodities knowledge hub</h1>
        <p>
          Master the commodities market with comprehensive industry reports.
        </p>
        <Link to="/signup">
          <button className="book-demo-btn">Book a demo</button>
        </Link>
      </div>
      <div className="reports-hero-graphic">
        <img src={graphicImg} alt="Reports and Data Graphic" />
      </div>
    </section>
  );
};

export default ReportsHero;